import type { FC } from 'react';
import React from 'react';
import classNames from 'clsx';
import { formatClassNames } from '@wix/editor-elements-common-utils';

import VectorImage from '../../../../../VectorImage/viewer/VectorImage';
import { TEST_ID_BADGE, TEST_ID_ICONS } from '../../../../constants';
import type { ILoginSocialBarProps } from '../../../../LoginSocialBar.types';
import semanticClassNames from '../../LoginSocialBar.semanticClassNames';
import styles from './LoginSocialBarIcons.module.scss';

type ILoginSocialBarIconsProps = Pick<ILoginSocialBarProps, 'iconItems'> & {
  className?: string;
  containerId: ILoginSocialBarProps['id'];
};

const getIconAriaLabel = (label: string, displayCount?: number) => {
  if (!label) {
    return;
  }
  return typeof displayCount === 'number' ? `${displayCount} ${label}` : label;
};

const getIconBadgeLabel = (count: number) => (count >= 100 ? '99+' : count);

export const LoginSocialBarIcons: FC<ILoginSocialBarIconsProps> = ({
  className: rootClassName,
  containerId,
  iconItems,
}) => {
  return (
    <div
      className={classNames(
        formatClassNames(semanticClassNames.icons),
        semanticClassNames.icons,
        rootClassName,
      )}
    >
      <nav className={styles.nav} data-testid={TEST_ID_ICONS}>
        {iconItems.map(
          ({ iconSvgContent, link, label, displayCount }, index) => (
            /**
             * TODO - reuse LogicSocialButton
             */
            <div
              key={index}
              className={classNames(styles.icon, {
                [styles.withCount]: typeof displayCount === 'number',
              })}
            >
              <VectorImage
                id={`${containerId}-icon`}
                link={link}
                svgContent={iconSvgContent}
                ariaAttributes={{ hidden: true }}
                ariaLabel={getIconAriaLabel(label, displayCount)}
                shouldScaleStroke={false}
                withShadow={false}
              />
              {typeof displayCount === 'number' && (
                <span className={styles.badge} data-testid={TEST_ID_BADGE}>
                  {getIconBadgeLabel(displayCount)}
                </span>
              )}
            </div>
          ),
        )}
      </nav>
    </div>
  );
};
